var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLeft = function SvgLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 0.999349C0.666504 0.539112 1.0396 0.166016 1.49984 0.166016C1.96007 0.166016 2.33317 0.539112 2.33317 0.999349V10.9993C2.33317 11.4595 1.96007 11.8326 1.49984 11.8326C1.0396 11.8326 0.666504 11.4595 0.666504 10.9993V0.999349Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6665 2.66636C15.6665 1.83302 15.6665 1.83302 14.8332 1.83302C13.9998 1.83302 7.17066 1.83302 6.49984 1.83302C5.6665 1.83302 5.6665 1.83302 5.6665 2.66636C5.6665 3.49969 5.6665 9.33262 5.6665 9.33262C5.6665 10.166 5.6665 10.166 6.49984 10.1664C6.49984 10.1664 13.9998 10.1665 14.8332 10.1664C15.6665 10.1664 15.6665 10.1664 15.6665 9.33302C15.6665 8.49969 15.6665 3.30288 15.6665 2.66636ZM5.6665 0.166357C4.74603 0.166357 3.99984 0.912549 3.99984 1.83302V10.1664C3.99984 11.0869 4.74603 11.8331 5.6665 11.8331L15.6665 11.8331C16.587 11.8331 17.3332 11.0869 17.3332 10.1664V1.83302C17.3332 0.912548 16.587 0.166356 15.6665 0.166356L5.6665 0.166357Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left.268f429b.svg";
export { ForwardRef as ReactComponent };